// #503: «пришёл новый ответ» в списке диалогов. Источник правды — сервер (`has_new_reply` в
// списке, отметка «прочитано» — POST /api/chats/<id>/read/); здесь — чистая логика провайдера:
// счётчик, правка строки списка и сообщение соседним вкладкам (storage-событие, без опросов).

export const UNREAD_EVENT_KEY = 'restorium.chat_unread_event';
// подсветка строки при появлении ответа (CSS-анимация ~1,8 с); дольше флаг «свежий» не держим —
// иначе строка, перемонтированная позже (шторка диалогов на телефоне), вспыхнула бы снова
export const FRESH_MS = 2500;
// тихое перечитывание флагов списка по возврату во вкладку — не чаще
export const REFRESH_MS = 30000;

export function unreadCount(chats) {
  return (chats || []).filter((c) => c && c.has_new_reply).length;
}

export function patchChat(list, id, patch) {
  if (!list) return list;
  let hit = false;
  const out = list.map((c) => {
    if (!c || c.id !== id) return c;
    hit = true;
    return { ...c, ...patch };
  });
  return hit ? out : list;
}

// Снять «свежесть», только если это та же вспышка (новая вспышка за это время — её не трогаем).
export function clearFresh(list, id, stamp) {
  if (!list) return list;
  return list.map((c) => (c && c.id === id && c.fresh === stamp ? { ...c, fresh: 0 } : c));
}

export function clearFreshAll(list, stamp) {
  if (!list) return list;
  return list.map((c) => (c && c.fresh === stamp ? { ...c, fresh: 0 } : c));
}

// Флаги из свежего списка сервера — строкам, которые уже есть (новые диалоги список добавит при
// загрузке). Новый флаг вспыхивает (fresh = stamp), снятый в другом месте — снимается.
export function mergeServerFlags(list, rows, stamp) {
  if (!list || !Array.isArray(rows)) return list;
  const byId = new Map(rows.filter((r) => r && r.id != null).map((r) => [String(r.id), r]));
  let changed = false;
  const out = list.map((c) => {
    const r = c && byId.get(c.id);
    if (!r || r.has_new_reply === undefined) return c;
    const flag = !!r.has_new_reply;
    if (flag === !!c.has_new_reply) return c;
    changed = true;
    return flag
      ? { ...c, has_new_reply: true, fresh: stamp, last_reply_at: r.last_reply_at || c.last_reply_at || null }
      : { ...c, has_new_reply: false, fresh: 0 };
  });
  return changed ? out : list;
}

export function encodeUnreadEvent(kind, ws, chatId) {
  return JSON.stringify({ kind, ws: String(ws), chat: String(chatId), t: Date.now() });
}

// Сообщение соседней вкладки → { kind, ws, chat } или null (чужой ключ, мусор, не тот вид).
export function parseUnreadEvent(key, raw) {
  if (key !== UNREAD_EVENT_KEY || !raw) return null;
  try {
    const e = JSON.parse(raw);
    if (!e || (e.kind !== 'read' && e.kind !== 'reply') || !e.chat || e.ws == null) return null;
    return { kind: e.kind, ws: String(e.ws), chat: String(e.chat) };
  } catch {
    return null;
  }
}

export function broadcastUnread(kind, ws, chatId) {
  try {
    window.localStorage.setItem(UNREAD_EVENT_KEY, encodeUnreadEvent(kind, ws, chatId));
  } catch { /* приватный режим / нет хранилища — соседние вкладки узнают при загрузке списка */ }
}
